<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLButtonElement> {
		active?: boolean;
		children: Snippet;
	}

	let { active = false, children, ...other }: Props = $props();
</script>

<li class:text-brown-1={!active} class:text-green-3={active}>
	<button type="button" {...other}>{@render children()}</button>
</li>
